import { render, staticRenderFns } from "./EditorPropertyImage.vue?vue&type=template&id=3dc7f473&lang=pug"
import script from "./EditorPropertyImage.vue?vue&type=script&lang=js"
export * from "./EditorPropertyImage.vue?vue&type=script&lang=js"
import style0 from "./EditorPropertyImage.vue?vue&type=style&index=0&id=3dc7f473&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports